import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CitizenHistoryService = {
    list: async (id, filters = {}) => axios.post(API_URL + `/reports/citizen-history-info/${id}/data`, filters).then(({data}) => data.history).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + `/sos/citizen/history/add`, data).catch((err) => { throw err }),

    edit: async (data) => axios.post(API_KEEPER + `/sos/citizen/history/update`, data,{headers: {'Content-Type': 'application/json'}}).catch((err) => { throw err }),
};

export default CitizenHistoryService;